import { useEffect } from "react";

/**
 * Sets document.title (and an Open Graph title meta tag) for the current page.
 * Restores the previous title when the component unmounts.
 *
 * Use on public-facing routes so iMessage/SMS link previews show the right
 * context (e.g., "Tides Team Quote — Q-2024-005" instead of the generic site title).
 */
export function useDocumentTitle(title) {
  useEffect(() => {
    if (!title) return;
    const prev = document.title;
    document.title = title;
    // Also sync og:title for share-card scrapers (iMessage refreshes on first fetch)
    const og = document.querySelector('meta[property="og:title"]');
    const prevOg = og?.getAttribute("content");
    if (og) og.setAttribute("content", title);
    return () => {
      document.title = prev;
      if (og && prevOg != null) og.setAttribute("content", prevOg);
    };
  }, [title]);
}
